import React from 'react';
import { JcColumn, JcRow } from '../JcBox';
import { JcLabel } from '../JcLabel';
import { JcMetaLabel } from '../JcMetaLabel';
import { JcCommonProps, JcUtils } from '../../utils/JcUtils';

export interface JcCardProps extends JcCommonProps {
    readonly title: string;
    /** Full-bleed content above the title, e.g. a cover image. */
    readonly media?: React.ReactNode;
    readonly tags?: ReadonlyArray<string>;
    readonly children?: React.ReactNode;
}

/** A content card. To make it navigate, wrap it in an unstyled link (`JcLink` / route link). */
export const JcCard = (props: JcCardProps): React.ReactElement => {
    const { title, media, tags, children } = props;
    const commonProps = JcUtils.commonProps(props, ["jc-card"]);
    return <JcColumn {...commonProps}>
        {media}
        <JcColumn className="jc-card-body" spacing flexGrow>
            <JcLabel className="jc-card-title" label={title} />
            {children}
            {tags && tags.length > 0 && <JcRow className="jc-card-tags">
                {tags.map(tag => <JcMetaLabel key={tag} className="jc-card-tag" label={tag} />)}
            </JcRow>}
        </JcColumn>
    </JcColumn>;
};
